import React, { FC, ReactElement, ReactNode } from 'react';
import { Formik, Field, FormikProps } from 'formik';

import { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import {
  FormValues,
  HandleMutations,
  JobApplication
} from 'buyside/components/container/JobApplicationShowPage/jobApplicationShowPageMutationsContainer';
import Button from 'buyside/components/presentation/Button/button';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

interface HandleSubmit {
  handleSubmit: HandleMutations['handleInterviewed'] | HandleMutations['handleRejected'];
}
export interface FormProps extends HandleSubmit {
  submitButtonText: string;
}
export type ModalProps = HandleSubmit &
  Pick<JobApplication, 'name'> & {
    renderOpenButton: (openModal: () => void) => ReactNode;
  };

export const JobApplicationMessageForm: FC<FormProps & {
  closeModal: () => void;
}> = ({ handleSubmit, submitButtonText, closeModal }): ReactElement => (
  <Formik<FormValues>
    onSubmit={(values, actions): ReturnType<HandleSubmit['handleSubmit']> =>
      handleSubmit(values, actions).then(result => {
        closeModal();
        return result;
      })
    }
    initialValues={{ message: '' }}
  >
    {({ submitForm }: FormikProps<FormValues>): ReactElement => (
      <>
        <Field name="message" component={InputField} type="textarea" />
        <Button
          data-test="submit-button"
          type={BUTTON_TYPES.PRIMARY}
          text={submitButtonText}
          onClick={submitForm}
        />
        <Button
          text="Cancel"
          onClick={(e: MouseEvent): void => {
            e.stopPropagation();
            closeModal();
          }}
        />
      </>
    )}
  </Formik>
);

export default JobApplicationMessageForm;
